import {withStyles} from "@material-ui/styles";
import React from "react";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Accordion from "@material-ui/core/Accordion";

export const AccordionStyled = withStyles({
    root: {
        '&::before': {
            height: 0
        }
    },


})((props) => <Accordion {...props}/>);

export const AccordionDetailStyled= withStyles({
    root: {
        display: "block",
        padding: 0
    }

})((props) => <AccordionDetails {...props}/>);

